import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getWeeklyProductViews } from '../../../../api/home/queries/getWeeklyProductViews';

export const useGetWeeklyProductViewsQuery = () => {
  return useQuery<number, AxiosError>(['weekly-product-views'], () => getWeeklyProductViews());
};
